import type { AppRole } from '../features/auth/auth.types'
import type { NavItem } from '../types'

export const workspaceNavigation: Record<AppRole, NavItem[]> = {
  patient: [
    { title: 'Dashboard', icon: 'bi-grid-1x2', path: '/patient/dashboard' },
    {
      title: 'Appointments', icon: 'bi-calendar2-check', children: [
        { title: 'My appointments', path: '/patient/appointments' },
        { title: 'Book appointment', path: '/patient/appointments/new' },
      ],
    },
    { title: 'Files and reports', icon: 'bi-folder2-open', path: '/patient/files' },
    { title: 'Prescriptions', icon: 'bi-file-earmark-medical', path: '/patient/prescriptions' },
    { title: 'Payments', icon: 'bi-credit-card', path: '/patient/payments' },
    { title: 'Profile', icon: 'bi-person-circle', path: '/patient/profile' },
    { title: 'Notifications', icon: 'bi-bell', path: '/patient/notifications' },
  ],
  doctor: [
    { title: 'Dashboard', icon: 'bi-grid-1x2', path: '/doctor/dashboard' },
    { title: 'Appointments', icon: 'bi-calendar2-check', children: [
      { title: 'Appointment list', path: '/doctor/appointments' }, { title: 'Calendar', path: '/doctor/calendar' }, { title: 'Availability', path: '/doctor/availability' },
    ] },
    { title: 'Patient care', icon: 'bi-people', children: [
      { title: 'Patients', path: '/doctor/patients' }, { title: 'Prescriptions', path: '/doctor/prescriptions' },
    ] },
    { title: 'Workspace', icon: 'bi-briefcase', children: [
      { title: 'Reports', path: '/doctor/reports' }, { title: 'Profile', path: '/doctor/profile' }, { title: 'Notifications', path: '/doctor/notifications' },
    ] },
  ],
  admin: [
    { title: 'Dashboard', icon: 'bi-grid-1x2', path: '/admin/dashboard' },
    { title: 'Clinical setup', icon: 'bi-hospital', children: [
      { title: 'Departments', path: '/admin/departments' }, { title: 'Services', path: '/admin/services' },
      { title: 'Fees & assignments', path: '/admin/doctor-services' }, { title: 'Availability', path: '/admin/availability' },
      { title: 'Leave & exceptions', path: '/admin/availability-exceptions' },
    ] },
    { title: 'People', icon: 'bi-people', children: [
      { title: 'Doctors', path: '/admin/doctors' }, { title: 'Patients', path: '/admin/patients' }, { title: 'Users', path: '/admin/users' },
    ] },
    { title: 'Care operations', icon: 'bi-calendar2-check', children: [
      { title: 'Appointments', path: '/admin/appointments' }, { title: 'Prescriptions', path: '/admin/prescriptions' },
    ] },
    { title: 'Finance', icon: 'bi-wallet2', children: [
      { title: 'Payments', path: '/admin/payments' }, { title: 'Refunds', path: '/admin/refunds' }, { title: 'Reports', path: '/admin/reports' },
    ] },
    { title: 'Content', icon: 'bi-window-stack', children: [
      { title: 'Public pages', path: '/admin/pages' }, { title: 'FAQs', path: '/admin/faqs' },
      { title: 'Notifications', path: '/admin/notifications' }, { title: 'Notification templates', path: '/admin/notification-templates' },
    ] },
    { title: 'System', icon: 'bi-sliders', children: [
      { title: 'Settings', path: '/admin/settings' }, { title: 'Audit logs', path: '/admin/audit-logs' },
    ] },
  ],
}
